import { useSearchParams } from 'react-router-dom';
import { forwardRef, useState, useEffect } from 'react';
import RecorderFactory from './recorders/RecorderFactory';
import { apiClient } from '../../services/apiClient';

const AudioRecorder = forwardRef((props, ref) => {
  const [searchParams] = useSearchParams();
  const [defaultRecorder, setDefaultRecorder] = useState('azure');
  
  useEffect(() => {
    const fetchDefaultRecorder = async () => {
      try {
        const response = await apiClient.get('/api/settings/stt-engine');
        setDefaultRecorder(response.value);
      } catch (error) {
        console.error('Error fetching STT engine setting:', error);
        // Keep azure as fallback if fetch fails
        setDefaultRecorder('azure');
      }
    };

    fetchDefaultRecorder();
  }, []);

  // Use URL param if present, otherwise use the fetched default
  const recorderType = searchParams.get('recorder') || defaultRecorder;

  return RecorderFactory.create(recorderType, { ...props, ref });
});

export default AudioRecorder; 